import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"
import { DrawerContext } from 'src/mtska-frontend-app-component/components/Drawer/DrawerContext';

const dataProviderName = 'cars/car';
const model = 'cars/car';
const modelExposedName = 'Car';
const wizardAction = 'massiveReadjustment';

const MassiveReadjustment = (params) => {

    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);
    const { close } = useContext(DrawerContext)

    const [drawable, setDrawable] = useState(false);
    //const [selectionStrategy, setSelectionStrategy] = useState('similarity');
    const { doAction, item, loadOne, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const detailConfig = {
        "tabs": [
            {
                "name": "car_massive_readjustment",
                "fieldsets": [
                    {
                        "name": "file_uploader",
                        "fields": {
                            "file": {
                                "type": "dropzone",
                                "required": true,
                                "className": "col-12",
                                "icon": "faChartNetwork"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    useEffect(() => {
        loadOne(null).then(e => setDrawable(true));
    }, []);

    const [editing, setEditing] = useState(true)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    disableDetailConfigOverride={true}
                    values={{}}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t('Apply massive readjustment')}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.create']}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t('Apply massive readjustment')}
                            subtitle={t('If you have previously exported a car list with the Readjustment format, you can upload here a file containing ONLY the rows that need to be readjusted. Please note that each row included in your file will be readjusted.')}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default MassiveReadjustment;


